// extracted by mini-css-extract-plugin
export default {"wrapper":"p2-z","play":"q2-z"};